import { useState, useContext } from 'react'
import axios from 'axios'
import { useRouter } from 'next/router'

// import Modal from 'react-bootstrap/Modal'
import Card from 'react-bootstrap/Card'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'

import styles from '../styles/Register.module.scss'

import UserContext from '../UserContext'

export default function MPSDemoModal(): JSX.Element {
	let emailAddr = ''
	if (typeof window !== 'undefined' && window.localStorage.getItem('profile') !== null) {
		emailAddr = JSON.parse(window.localStorage.getItem('profile') as string).email
	}
	// const [inputs, setInputs] = useState({
	// 	emailAddr: initialEmail,
	// 	password: ''
	// })
	const [password, setPassword] = useState('')
	const [isLoading, setIsLoading] = useState(false)

	const { user } = useContext(UserContext)

	const router = useRouter()

	const handleSubmit = (event) => {
		event.preventDefault()
		event.stopPropagation()

		setIsLoading(true)

		let token = ''
		if (typeof window !== 'undefined' && window.localStorage.getItem('token')) token = window.localStorage.getItem('token') as string
		
		axios.post(process.env.NEXT_PUBLIC_SIGNUP_UPDATE_PASSWORD as string, {
			id: user.id,
			password,
			token
		}).then(() => {
			router.push('/browse-jobs')
			setIsLoading(false)
		}).catch(() => setIsLoading(false))
	}

	return (
		// <Modal show={show} onHide={() => setShow(false)}>
		<Card className='w-50 p-5 mx-auto my-4'>
			{/* <Modal.Header closeButton /> */}
			<Card.Body style={{ boxShadow: 'none' }}>
				<h1 className={styles.profileHeader}>Create your account and Findjobs now!</h1>
				<Form onSubmit={handleSubmit}>
					<Form.Group className="mb-3" controlId="formBasicEmail">
						<Form.Label>Email Address</Form.Label>
						<Form.Control
							type="email"
							placeholder="Enter email"
							readOnly
							value={emailAddr}
						/>
					</Form.Group>

					<Form.Group className="mb-5" controlId="formBasicPassword">
						<Form.Label>Password</Form.Label>
						<Form.Control
							type="password"
							placeholder="Password"
							required
							minLength={8}
							onChange={e => setPassword(e.target.value)}
							value={password}
						/>
					</Form.Group>

					<Button type='submit' className='text-white w-100' disabled={isLoading}>Submit</Button>
				</Form>
			</Card.Body>
		</Card>
	)
}